<template xmlns="http://www.w3.org/1999/html">
    <div>
        <h2>{{ step.title }}</h2>
        <p class="step__notice">
            All fields with an asterisk are required
            <i class="fas fa-asterisk"></i>
        </p>
        <InputRadioGroup
            name="which_ethnic_background"
            :required="checkIsRequired('which_ethnic_background')"
            :error="formRef.errors.get('which_ethnic_background')"
            v-model="formRef.which_ethnic_background"
            :options="getField('which_ethnic_background')['options']"
        >
            <template v-slot:question>
                {{ getField("which_ethnic_background").question }}
            </template>
        </InputRadioGroup>

        <InputRadioGroup
            v-if="formRef.which_ethnic_background === 'Asian/Asian British'"
            name="which_asian_background"
            :required="checkIsRequired('which_asian_background')"
            :error="formRef.errors.get('which_asian_background')"
            v-model="formRef.which_asian_background"
            :options="getField('which_asian_background')['options']"

        >
            <template v-slot:question>
                {{ getField("which_asian_background").question }}
            </template>
        </InputRadioGroup>

        <InputRadioGroup
            v-if="formRef.which_ethnic_background === 'Black/African/Caribbean/Black British'"
            name="which_black_background"
            :required="checkIsRequired('which_black_background')"
            :error="formRef.errors.get('which_black_background')"
            v-model="formRef.which_black_background"
            :options="getField('which_black_background')['options']"
        >
            <template v-slot:question>
                {{ getField("which_black_background").question }}
            </template>
        </InputRadioGroup>

        <InputRadioGroup
            v-if="formRef.which_ethnic_background === 'Mixed/Multiple Ethnic Groups'"
            name="which_mixed_background"
            :required="checkIsRequired('which_mixed_background')"
            :error="formRef.errors.get('which_mixed_background')"
            v-model="formRef.which_mixed_background"
            :options="getField('which_mixed_background')['options']"
        >
            <template v-slot:question>
                {{ getField("which_mixed_background").question }}
            </template>
        </InputRadioGroup>

         <InputRadioGroup
            v-if="formRef.which_ethnic_background === 'White'"
            name="which_white_background"
            :required="checkIsRequired('which_white_background')"
            :error="formRef.errors.get('which_white_background')"
            v-model="formRef.which_white_background"
            :options="getField('which_white_background')['options']"
        >
            <template v-slot:question>
                {{ getField("which_white_background").question }}
            </template>
        </InputRadioGroup>

         <InputRadioGroup
            v-if="formRef.which_ethnic_background === 'Other ethnic group'"
            name="which_other_background"
            :required="checkIsRequired('which_other_background')"
            :error="formRef.errors.get('which_other_background')"
            v-model="formRef.which_other_background"
            v-model:other-text="formRef.any_other_ethnic"
            :options="getField('which_other_background')['options']"
            :form="formRef"
        >
            <template v-slot:question>
                {{ getField("which_other_background").question }}
            </template>
        </InputRadioGroup>

        <InputRadioGroup
            name="which_religion"
            :required="checkIsRequired('which_religion')"
            :error="formRef.errors.get('which_religion')"
            v-model="formRef.which_religion"
            v-model:other-text="formRef.any_other_religion"
            :options="getField('which_religion')['options']"
            :form="formRef"
        >
            <template v-slot:question>
                {{ getField("which_religion").question }}
            </template>
        </InputRadioGroup>
    </div>
</template>



<script setup>
import InputRadioGroup from "../Form/InputRadioGroup";
import Form from "../../Form";
import { isRequired } from "./helpers";
import { ref, markRaw } from "vue";

const props = defineProps({
    step: Object,
    fields: Object,
    formData: Object
})

let formRef = markRaw(ref(new Form({
    which_ethnic_background: null,
    which_asian_background: null,
    which_black_background: null,
    which_mixed_background: null,
    which_white_background: null,
    which_other_background: null,
    any_other_ethnic: null,
    which_religion: null,
    any_other_religion: null
}, props.formData)))

const getField = (fieldName) => {
   return props.fields[fieldName];
}

const checkIsRequired = (fieldName) => {
   var fieldData = getField(fieldName);
   return isRequired(fieldData, formRef.value);
}

defineExpose({
 formRef
})
</script>
